var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "b",
    d: "m34.52761,30.25643l-6.81928-6.81572c-.30868-.30726-.72692-.47917-1.16252-.47784h-1.11525c4.83168-6.18953,3.72958-15.12294-2.46159-19.95333C16.7778-1.82085,7.84202-.71905,3.01034,5.47048-1.82133,11.66001-.71924,20.59342,5.47194,25.42381c5.14207,4.01187,12.35497,4.01187,17.49704,0v1.11495c-.00134.43548.17062.85361.47796,1.16221l6.81928,6.81747c.63708.63994,1.67245.64239,2.31255.00548.00183-.00182.00366-.00365.00548-.00548l1.93636-1.93584c.63919-.64305.63919-1.68137,0-2.32441l.00701-.00175Zm-20.30903-7.2953c-4.83464,0-8.75389-3.91821-8.75389-8.75156s3.91925-8.75156,8.75389-8.75156,8.75389,3.91821,8.75389,8.75156-3.91925,8.75156-8.75389,8.75156h-.0035.0035Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.da2cb981de4efd75a8767aabac0baf05.svg";
export { ForwardRef as ReactComponent };